import { LogLevel } from "@hotelchamp/common";
import { z } from "zod/v4";

export const DebugConfigSchema = z
    .object({
        logLevel: z.enum(LogLevel).optional().default(LogLevel.Info), // not used yet, what whould load first? log or config?
    })
    .optional()
    .default({} as any); // default to empty to make sure default values are used

export type TDebugConfig = z.infer<typeof DebugConfigSchema>;
